module.exports = __webpack_public_path__ + "img/ys1.04ea2dcf.png";